export default{
    main:{
        title:'ai en title',
        bannertitle:'Expert in intelligent manufacturing of photovoltaic modules.',
        serviceslist: [
            {
                name: 'Improve component production digitization.',
                detail: 'The combination of intelligent manufacturing based on emerging technologies such as artificial intelligence, industrial internet, and big data with the photovoltaic industry has become mature.'
            },
            {
                name: 'Dual improvement in production efficiency and quality.',
                detail: 'Through the system, more reasonable long-term solutions can be obtained, optimizing work efficiency, streamlining manpower, and improving quality.'
            },
            {
                name: 'Eliminate the generation of batch defects.',
                detail: 'Shift production to rely more on intelligent assembly line processes, and gradually develop comprehensive quality management stages from the inspection stage in terms of quality control.'
            },
            {
                name: 'Optimize production resource allocation.',
                detail: 'By highly integrating and visualizing the detection information throughout the process, the information collection of the production process can be achieved.'
            },
            {
                name: 'Control the transmission of critical defects.',
                detail: 'Combining process experience with image big data algorithms, an automatic, real-time, and intelligent platform can replace the cumbersome process of analyzing data and locating equipment faults.'
            },
            {
                name: 'Comprehensive technological empowerment.',
                detail: 'With the continuous improvement of automation in photovoltaic manufacturing, intelligence has become the primary goal of major factories. Currently, 70%-80% of the market has been transformed.'
            }

        ],
        maodianlist: [
            {
                name: 'Home',
                detail: 'body'

            },
            {
                name: 'Services',
                detail: 'services'
            },
            {
                name: 'Products',
                detail: 'products'
            },
            {
                name: 'Work',
                detail: 'work'
            },
            {
                name: 'Contact Us',
                detail: 'contact'
            }
        ],
    }
}